module.exports = __webpack_public_path__ + "ea94fcf1b527a67a649f4ffc49611d92.svg";